import React from 'react';
import { parseQueryResults } from './util.jsx';

const defaultDashboard = 'A';

class KingEdition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: [],
      error: null,
      result: '',
      dashboards: [],
      currentDashboard: null
    }
  }

  onDashboardChange = (event) => {
    this.loadSavedData(event.target.value);
    this.setState({
      currentDashboard: event.target.value
    });
  }

  onInputChange = (name, event) => {
    let value = event.target.value;
    if (value != null) {
      if (value.trim() == '') {
        value = null;
      }
      this.setState({
        [name]: value
      });
    }
  }

  onNameChange = (index, event) => {
    const data = this.state.data;
    data[index].name = event.target.value;
    this.setState({
      data
    });
  }

  onQueryChange = (index, event) => {
    const data = this.state.data;
    data[index].query = event.target.value;
    this.setState({
      data
    });
  }

  onAggregationChange = (index, event) => {
    const data = this.state.data;
    data[index].aggregation = event.target.value;
    this.setState({
      data
    });
  }

  onFilterChange = (index, event) => {
    const data = this.state.data;
    data[index].filter = event.target.value;
    this.setState({
      data
    });
  }

  refresh = () => {
    // set loading state
    this.setState({
      loading: 'Loading...'
    });
    // replace {company}
    const data = this.state.data.map(request => {
      let query = request.query;
      if (this.state.company && this.state.company.length > 0) {
        if (request.query.length > 0) {
          query += ',' + this.state.company;
        } else {
          query = this.state.company;
        }
      }
      return {
        aggregation: request.aggregation.replace('{company}', this.state.company),
        filter: request.filter.replace('{company}', this.state.company),
        query: query.replace('{company}', this.state.company),
      }
    });
    // build payload
    const body = {
      environmentId: this.state.environmentId,
      collectionId: this.state.collectionId,
      data: data,
      company: this.state.company,
      return: 'title,text,url'
    };
    const host = process.env.REACT_APP_SERVER;
    fetch(`${host}/api/batch`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then((response) => {
      console.log(response);
      if (response.ok) {
        response.json().then((json) => {
          this.setState({ loading: false, data: parseQueryResults(this.state.data, json) });
        });
      } else {
        response.text().then((err) => {
          this.setState({ error: JSON.parse(err).error, loading: false });
          alert(JSON.parse(err).error);
        }).catch(() => {
          this.setState({
            error: 'There was a problem with the request, please try again',
            loading: false,
          });
        });
      }
    });
  }

  remove = (index) => {
    const data = this.state.data;
    data.splice(index, 1);
    if (data.length === 0) {
      data.push({
        name: '',
        query: '',
        aggregation: '',
        filter: '',
      });
    }
    this.setState({
      data
    });
  }

  add = () => {
    const data = this.state.data;
    data.push({
      name: '',
      query: '',
      aggregation: '',
      filter: '',
    })
    this.setState({
      data
    });
  }

  clear = () => {
    this.setState({
      data: [{
        name: '',
        query: '',
        aggregation: '',
        filter: '',
      }]
    });
  }

  save = () => {
    const data = this.state.data.map(d => {
      return {
        name: d.name,
        query: d.query,
        aggregation: d.aggregation,
        filter: d.filter
      }
    });

    const host = process.env.REACT_APP_SERVER;
    const dashboard = this.state.name || defaultDashboard;

    fetch(`${host}/api/save`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: dashboard,
        environmentId: this.state.environmentId,
        collectionId: this.state.collectionId,
        data: data,
        company: this.state.company
      }),
    }).then((response) => {
      this.loadDashboards();
      this.loadSavedData(dashboard);
      this.setState({
        currentDashboard: dashboard
      });
    });
  }

  loadSavedData = (name) => {
    const host = process.env.REACT_APP_SERVER;
    let url = `${host}/api/load`;


    url += `?name=${name || defaultDashboard}`;

    fetch(url, {
      method: 'GET'
    }).then((response) => {
      if (response.ok) {
        response.json().then((storedData) => {
          if (storedData && storedData.data) {
            this.setState({
              name: storedData.name || '',
              environmentId: storedData.environmentId || '',
              collectionId: storedData.collectionId || '',
              data: storedData.data,
              company: storedData.company || ''
            });
          } else {
            const defaultState = [{"name":"Technology initiatives","query":"","aggregation":"","filter":"enriched_title.semantic_roles.subject.entities.type::\"Company\",enriched_text.semantic_roles.object.text:\"initiative\",enriched_text.semantic_roles.object.text::!\"initial\",enriched_title.categories.label:\"technology\""},{"name":"Technology areas of focus","query":"","aggregation":"","filter":"enriched_title.semantic_roles.subject.entities.type::\"Company\",enriched_title.semantic_roles.object.text:\"focus\""},{"name":"Areas companies are conducting research","query":"","aggregation":"","filter":"enriched_title.semantic_roles.subject.entities.type::\"Company\",enriched_title.semantic_roles.action.verb.text:\"conduct\",enriched_title.semantic_roles.object.text:\"research\""},{"name":"Company finance in reported revenue","query":"","aggregation":"","filter":"enriched_title.semantic_roles.subject.entities.type::\"Company\",enriched_title.semantic_roles.action.verb.text:\"report\",enriched_title.semantic_roles.object.text:\"revenue\""},{"name":"Company investments","query":"","aggregation":"","filter":"enriched_title.semantic_roles.subject.entities.type::\"Company\",enriched_title.semantic_roles.action.verb.text:\"invest\""},{"name":"Company acquisitions","query":"","aggregation":"","filter":"enriched_title.semantic_roles.subject.entities.type::\"Company\",enriched_title.semantic_roles.action.verb.text:\"acquire\""},{"name":"Company launches","query":"","aggregation":"","filter":"enriched_title.semantic_roles.subject.entities.type::\"Company\",enriched_title.semantic_roles.action.verb.text:\"launch\""},{"name":"Company announcements","query":"","aggregation":"","filter":"enriched_title.semantic_roles.subject.entities.type::\"Company\",enriched_title.semantic_roles.action.verb.text:\"announce\", enriched_text.semantic_roles.action.verb.text::!\"expect\""},{"name":"Company patent filings","query":"","aggregation":"","filter":"enriched_title.semantic_roles.subject.entities.type::\"Company\",enriched_title.semantic_roles.action.verb.text:\"file\",enriched_title.semantic_roles.object.text:\"patent\""}];
            this.setState({
              data: defaultState
            });
          }
        });
      } else {
        response.text().then((err) => {
          this.setState({ error: JSON.parse(err).error, loading: false });
          alert(JSON.parse(err).error);
        }).catch(() => {
          this.setState({
            error: 'There was a problem with the request, please try again',
            loading: false,
          });
        });
      }
    });
  }

  loadDashboards = () => {
    const host = process.env.REACT_APP_SERVER;

    return fetch(`${host}/api/dashboards`, {
      method: 'GET'
    }).then((response) => {
      if (response.ok) {
        response.json().then((dashboards) => {
          if (dashboards) {
            this.setState({
              dashboards
            });
          } else {
            this.setState({
              dashboards: [defaultDashboard]
            });
          }
        });
      } else {
        response.text().then((err) => {
          this.setState({ error: JSON.parse(err).error, loading: false });
          alert(JSON.parse(err).error);
        }).catch(() => {
          this.setState({
            error: 'There was a problem with the request, please try again',
            loading: false,
          });
        });
      }
    });;
  }

  componentDidMount() {
    this.loadDashboards();
    this.loadSavedData();
  }

  render() {

    return (
      <div>
        <h1 className="title">Zephyr - Limited Edition ♚</h1>
        <div className="dashboard">
          <h2>Select Your Dashboard:</h2>
          <select onChange={this.onDashboardChange} value={this.state.currentDashboard}>
            {this.state.dashboards.map(dashboard => {
              return <option value={dashboard}>{dashboard}</option>;
            })}
          </select>
        </div>
        <div className="tool-config">
          <h2>Dashboard Name</h2>
          <input type="text" value={this.state.name} onChange={this.onInputChange.bind(this, 'name')}/>
          <h2>Company</h2>
          <input type="text" value={this.state.company} onChange={this.onInputChange.bind(this, 'company')}/>
          <h2>Environment ID</h2>
          <input type="text" value={this.state.environmentId} onChange={this.onInputChange.bind(this, 'environmentId')}/>
          <h2>Collection ID</h2>
          <input type="text" value={this.state.collectionId} onChange={this.onInputChange.bind(this, 'collectionId')}/>
        </div>
        <div className="tool-container">
          <div className="action-bar">
            <button className="add-button" onClick={this.add}>Add</button>
            <button className="add-button" onClick={this.clear}>Clear</button>
            <button className="go-button" onClick={this.refresh}>Get Data</button>
            <button className="go-button" onClick={() => {
                if (window.confirm(`Are you sure you wish to save: ${this.state.name}?`)) this.save();
            }}>Save Dashboard</button>

            <div className="clear"></div>
          </div>
          {this.state.data.map((row, index) => {
            return (
              <div className="box-container">
                <div className="input-box">
                  <h2>Name</h2>
                  <textarea value={row.name} onChange={this.onNameChange.bind(this, index)}/>
                  <h2>Query</h2>
                  <textarea value={row.query} onChange={this.onQueryChange.bind(this, index)}/>
                  <h2>Aggregation</h2>
                  <textarea value={row.aggregation} onChange={this.onAggregationChange.bind(this, index)}/>
                  <h2>Filter</h2>
                  <textarea value={row.filter} onChange={this.onFilterChange.bind(this, index)}/>
                </div>
                <div className="output-box">
                  <h2>Result</h2>
                  <div className="results">
                    {this.state.loading || row.result}
                  </div>
                  <button className="delete-button" onClick={this.remove.bind(this, index)}>Remove</button>
                </div>
              </div>
            );
          })}
        </div>

        <div className="action-bar">
          <button className="add-button" onClick={this.add}>Add</button>
          <button className="add-button" onClick={this.clear}>Clear</button>
          <button className="go-button" onClick={this.refresh}>Get Data</button>
          <button className="go-button" onClick={() => {
              if (window.confirm(`Are you sure you wish to save: ${this.state.name}?`)) this.save();
          }}>Save Dashboard</button>

          <div className="clear"></div>
        </div>
      </div>
    );
  }
}

export default KingEdition;
